export default "__VITE_ASSET__DM2tPRQV__"